import React from 'react';

/**
 * Standardized action bar for page headers
 * Ensures perfect alignment and spacing of action buttons
 */
const ActionBar = ({ children, className = '' }) => {
  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      {children}
    </div>
  );
};

export default ActionBar;
